import { useFormContext, useFormState } from 'react-hook-form';

const useDirtyFields = () => {
    const { getValues } = useFormContext();
    const { isDirty, dirtyFields } = useFormState();

    const getDirtyFieldsWithValues = () => {
        const allValues = getValues();
        const dirtyFieldsWithValues: any = {};
        for (const field in dirtyFields) {
            if (dirtyFields[field]) {
                dirtyFieldsWithValues[field] = allValues[field];
            }
        }
        return dirtyFieldsWithValues;
    };

    return { isDirty, getDirtyFieldsWithValues };
};

export {useDirtyFields};
